module.exports = __webpack_public_path__ + "img/cover-agriculture.ce531240.jpg";